const pckContext = require.context("./global", true, /\.js$/);
const componentsArr = pckContext.keys().map(comPath => {
  return pckContext(comPath).default || pckContext(comPath);
});
export default {
  install: function (Vue) {
    componentsArr.forEach(comp => {
      Vue.component(comp.componentName, comp);
    });
  }
};
